var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5C3.72386 6.5 3.5 6.72386 3.5 7C3.5 7.27614 3.72386 7.5 4 7.5H5C5.27614 7.5 5.5 7.27614 5.5 7C5.5 6.72386 5.27614 6.5 5 6.5H4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.5V3.5H15C16.6569 3.5 18 4.84315 18 6.5V12.5C18 14.1569 16.6569 15.5 15 15.5H14V17.5C14 18.0523 13.5523 18.5 13 18.5H5C4.44772 18.5 4 18.0523 4 17.5V15.5H3C1.34315 15.5 0 14.1569 0 12.5V6.5C0 4.84315 1.34315 3.5 3 3.5H4V1.5C4 0.947715 4.44772 0.5 5 0.5H13C13.5523 0.5 14 0.947715 14 1.5ZM5.5 3.5V2H12.5V3.5H5.5ZM15 14H14V10.5C14 9.94772 13.5523 9.5 13 9.5H5C4.44772 9.5 4 9.94771 4 10.5V14H3C2.17157 14 1.5 13.3284 1.5 12.5V6.5C1.5 5.67157 2.17157 5 3 5H15C15.8284 5 16.5 5.67157 16.5 6.5V12.5C16.5 13.3284 15.8284 14 15 14ZM5.5 11H12.5V17H5.5V11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.25C7 14.9739 7.22386 14.75 7.5 14.75H10.5C10.7761 14.75 11 14.9739 11 15.25C11 15.5261 10.7761 15.75 10.5 15.75H7.5C7.22386 15.75 7 15.5261 7 15.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.25C7.22386 12.25 7 12.4739 7 12.75C7 13.0261 7.22386 13.25 7.5 13.25H10.5C10.7761 13.25 11 13.0261 11 12.75C11 12.4739 10.7761 12.25 10.5 12.25H7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.02521c837b07a2a9e6f2dd2ddf229745.svg";
export { ForwardRef as ReactComponent };